<template>
  <div>
    <inventory-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/admin/inventory/list')"
      @list="$router.push('/admin/inventory/list')"
      @change="id=> $router.push('/admin/inventory/change?id=' + id)"
      @view="id=> $router.push('/admin/inventory/view?id=' + id)"
    />
  </div>
</template>
<script>
import InventoryForm from "@/views/admin/components/Inventory-form.vue"

export default {
  components: { InventoryForm },
  props: ['create', 'change', 'view'],
  data: () => ({}),
}
</script>

<style scoped>

</style>
